export default function SDFRoleSection() {
  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="section-heading">
              The Skills Development Facilitator (SDF) Role
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              Every company liable for the Skills Development Levy must appoint a Skills Development Facilitator to manage compliance and coordinate training initiatives.
            </p>

            <div className="bg-gray-50 p-6 rounded-xl mb-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                Key SDF Responsibilities:
              </h3>
              <div className="space-y-3">
                <div className="flex items-start">
                  <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Develop and submit Workplace Skills Plans (WSP)</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Compile and submit Annual Training Reports (ATR)</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Coordinate skills development activities</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Liaise with SETA representatives</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Manage discretionary grant applications</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-check-line text-[#2D7F3E] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-600">Monitor training compliance and outcomes</span>
                </div>
              </div>
            </div>

            <div className="bg-[#2D7F3E] text-white p-6 rounded-xl">
              <h3 className="text-xl font-semibold mb-3">
                We Offer SDF Advisory Services
              </h3>
              <p className="text-green-100 mb-4">
                Don't have an experienced SDF? Our certified specialists can provide ongoing support or act as your external SDF consultant.
              </p>
              <button className="btn btn-white">
                Learn About SDF Support
              </button>
            </div>
          </div>

          <div className="bg-gray-50 p-8 rounded-xl">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20Skills%20Development%20Facilitator%20working%20at%20desk%20with%20training%20documents%20and%20compliance%20paperwork%2C%20modern%20office%20environment%20with%20computer%20and%20SETA%20materials%2C%20focused%20professional%20reviewing%20skills%20development%20plans%20and%20reports&width=600&height=400&seq=sdf-role&orientation=landscape"
              alt="Skills Development Facilitator at work"
              className="w-full h-64 object-cover rounded-lg mb-6"
            />
            
            <div className="space-y-4">
              <h3 className="text-xl font-semibold text-gray-900">
                SDF Qualifications & Training
              </h3>
              <p className="text-gray-600">
                While no formal qualification is required, SDFs benefit greatly from specialised training in:
              </p>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-graduation-cap-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                  <span className="text-gray-600">SETA compliance requirements</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-graduation-cap-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                  <span className="text-gray-600">WSP and ATR preparation</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-graduation-cap-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                  <span className="text-gray-600">Grant application processes</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-graduation-cap-line text-[#2D7F3E] text-lg mr-3 mt-1"></i>
                  <span className="text-gray-600">Skills development planning</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}